import React, { memo, ReactElement, SyntheticEvent } from 'react';

import cls from 'classnames';

import _noop from 'lodash/noop';

import LikeIcon from '@ott/icon-like';

import useLike, { SuccessfulLikeSetResult } from './effects/useLike';

import styles from './ActivitiesLike.scss';

export type ActivitiesLikeProps = {
  activityId: number;
  className?: string;
  isLiked: boolean;
  onClick?: (event: SyntheticEvent) => void;
  onUpdateSuccess: ({ activityId, isLiked }: SuccessfulLikeSetResult) => void;
  preset?: 'onDark' | 'onLight';
};

const ActivitiesLike = ({
  activityId,
  className,
  isLiked,
  onClick = _noop,
  onUpdateSuccess,
  preset = 'onDark',
}: ActivitiesLikeProps): ReactElement => {
  const { expectedIsLiked, isLoading, setActivityLikedTo } = useLike();

  // eslint-disable-next-line consistent-return
  const handleClick = async (event: SyntheticEvent) => {
    onClick(event);

    if (isLoading) {
      return null;
    }

    const result = await setActivityLikedTo(activityId, !isLiked);

    if (result) {
      onUpdateSuccess(result);
    }
  };

  const visibleIsActive = isLoading ? expectedIsLiked : isLiked;

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={cls(styles.container, visibleIsActive && styles.isActive, className)}
      onClick={handleClick}
    >
      <LikeIcon
        isActive={Boolean(visibleIsActive)}
        shapeClassName={styles.iconShape}
        preset={preset}
      />
    </div>
  );
};

export default memo(ActivitiesLike);
